import { render } from "./SlTableRow.vue?vue&type=template&id=24f2d9a9&scoped=true"
import script from "./SlTableRow.vue?vue&type=script&lang=js"
export * from "./SlTableRow.vue?vue&type=script&lang=js"

import "./SlTableRow.vue?vue&type=style&index=0&id=24f2d9a9&lang=scss&scoped=true"
import "./SlTableRow.vue?vue&type=style&index=1&id=24f2d9a9&lang=scss"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f2d9a9"]])

export default __exports__